import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';
import { OnlyFansUser } from './useInsightsUserProfile';
import useSubscriber from './useSubscriber';

const useSubscriberUsernameSearchX = (username: string | null) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const { data: subscriber } = useSubscriber();
    const axios = useAxios();

    const fetchData = async (): Promise<OnlyFansUser | null> => {
        if (!subscriber) {
            return null;
        }

        if (!username) {
            return null;
        }

        const query: string = `${settingsContext.routes.onlyFans.base}${subscriber._id}/users/find/x?${new URLSearchParams({
            username: username,
        })}`;

        return axios
            .get(query)
            .then(response => response.data)
            .catch(() => {
                return [];
            });
    };

    const query = useQuery(['subscriberUsernameSearchX', subscriber?._id, username], () => fetchData(), {
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        refetchInterval: false,
        enabled: userContext.jwtToken && settingsContext.apiKey && subscriber?._id ? true : false,
    });

    return { ...query };
};

export default useSubscriberUsernameSearchX;
